export default "__VITE_ASSET__282bbae0__"